<template>
  <div>
    <check-detail-new v-if="isNewInspection" :data="data" :print-width="printWidth" />
    <check-detail-legacy v-else :data="data" :print-width="printWidth" />
  </div>
</template>

<script>
import CheckDetailNew from "./checkDetailNew.vue";
import CheckDetailLegacy from "./checkDetailLegacy.vue";

export default {
  name: "CheckDetail",
  components: {
    CheckDetailNew,
    CheckDetailLegacy
  },
  props: {
    printWidth: {
      type: Number,
      default: 210
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isNewInspection() {
      const source = this.data || {};
      const detail = source.detail || {};
      const items = source.items || [];

      const newItemNames = [
        "左前轮胎安全检查",
        "右前轮胎安全检查",
        "左后轮胎安全检查",
        "右后轮胎安全检查",
        "底盘和电池检查",
        "灯光和外观检查",
        "车内检查"
      ];
      const hasNewItem = items.some((item) => item && newItemNames.includes(item.itemName));
      if (hasNewItem) {
        return true;
      }

      const hasNewFlagField =
        this.isNotBlank(detail.allBrake) ||
        this.isNotBlank(detail.allLight) ||
        this.hasArrayData(detail.tirePhotoLf) ||
        this.hasArrayData(detail.tirePhotoRf) ||
        this.hasArrayData(detail.tirePhotoLb) ||
        this.hasArrayData(detail.tirePhotoRb);

      return hasNewFlagField;
    }
  },
  methods: {
    isNotBlank(value) {
      return value !== undefined && value !== null && String(value).trim() !== "";
    },
    hasArrayData(value) {
      return Array.isArray(value) && value.length > 0;
    }
  }
};
</script>
